import * as actionTypes from '../actions/actionTypes';

const initialState = {
    details: [],
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.TICKET_DETAILS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                details: []
            };
        case actionTypes.TICKET_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                details: []
            };
        case actionTypes.TICKET_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                details: action.payload.data
            };
        default:
            return state;
    }
};

export default reducer;